<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-4">
              <div class="card-header pb-0">
                <h6>Faktur Vendor (Tagihan Supplier)</h6>
                <p class="text-xs mb-0">Sumber PPN Masukan & pemotongan PPh 23 / 4(2). Posting = masuk hutang, laporan pajak, dan jurnal.</p>
              </div>
            </div>
            <div class="col-lg-3">
              <input type="text" class="form-control mt-3" placeholder="Cari PO / No. Invoice / Faktur Pajak / Vendor" v-model="search.search" v-on:keyup.enter="get()">
            </div>
            <div class="col-lg-2">
              <input type="month" class="form-control mt-3" v-model="search.period" @change="get()" title="Periode tanggal invoice">
            </div>
            <div class="col-lg-1">
              <select class="form-select mt-3" v-model="search.status" @change="get()">
                <option value="">Semua</option>
                <option value="Draft">Draft</option>
                <option value="Posted">Posted</option>
              </select>
            </div>
            <div class="col-lg-2">
              <argon-button class="mt-4" variant="gradient" color="success" size="sm" @click="openForm(null)"><i class="fa fa-plus fa-sm"></i> Faktur Baru</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Tgl Invoice</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">No. Invoice</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PO / Vendor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Faktur Pajak</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">DPP</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PPN</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">PPh Dipotong</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Dibayar ke Vendor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Jatuh Tempo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center text-xs">{{ moment(row.invoice_date).locale('id').format('ll') }}</td>
                    <td class="align-middle text-center text-xs font-weight-bold">{{ row.invoice_no }}</td>
                    <td class="align-middle text-xs">
                      <span class="badge badge-sm bg-gradient-primary">{{ row.po_no }}</span><br>{{ row.company_name }}
                    </td>
                    <td class="align-middle text-center text-xs">{{ row.faktur_pajak_no || '-' }}</td>
                    <td class="align-middle text-end text-xs">{{ fmt(row.dpp) }}</td>
                    <td class="align-middle text-end text-xs">{{ fmt(row.ppn_amount) }}</td>
                    <td class="align-middle text-end text-xs">
                      <span v-if="Number(row.pph_amount) > 0">{{ fmt(row.pph_amount) }}<br><span class="text-xxs">PPh {{ row.pph_type }} {{ Number(row.pph_rate) }}%</span></span>
                      <span v-else>-</span>
                    </td>
                    <td class="align-middle text-end text-xs font-weight-bold">{{ fmt(row.net_payable) }}</td>
                    <td class="align-middle text-center text-xs">{{ row.due_date ? moment(row.due_date).locale('id').format('ll') : '-' }}</td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success" v-if="row.status == 'Posted'">Posted</span>
                      <span class="badge badge-sm bg-gradient-secondary" v-else>Draft</span>
                    </td>
                    <td class="text-xs">
                      <span v-if="row.status == 'Draft'">
                        <i class="fas fa-edit" style="cursor: pointer; margin-right: 12px;" title="Ubah faktur" @click="openForm(row)"></i>
                        <i class="fa fa-check-circle text-success" style="cursor: pointer; margin-right: 12px;" title="Posting faktur (masuk hutang, pajak, jurnal)" @click="action('post', row)"></i>
                        <i class="fa fa-trash" style="cursor: pointer;" title="Hapus faktur" @click="action('delete', row)"></i>
                      </span>
                      <i class="fa fa-undo" style="cursor: pointer;" title="Batalkan posting (kembali ke Draft)" @click="action('unpost', row)" v-else></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
            <div class="float-right">
              <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL FORM FAKTUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formShow" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">{{ form.id ? 'Ubah' : 'Input' }} Faktur Vendor</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formShow = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <div class="row">
          <div class="col-md-4">
            <label class="form-control-label">No. PO <span style="color: red;">*</span></label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="PO-PROC-.." v-model="form.po_no" v-on:keyup.enter="loadSuggest()">
              <button class="btn btn-sm btn-outline-primary mb-0" type="button" @click="loadSuggest()">Ambil</button>
            </div>
          </div>
          <div class="col-md-8">
            <label class="form-control-label">Vendor <span style="color: red;">*</span></label>
            <select class="form-select" v-model="form.vendor_code" @change="applySuggest()">
              <option v-for="(v, i) in vendors" :key="'v'+i" :value="v.vendor_code">{{ v.company_name }} ({{ v.vendor_code }}) {{ v.has_npwp ? '' : '- TANPA NPWP' }}</option>
            </select>
          </div>
        </div>
        <p class="text-xs mt-2 mb-0" v-if="selectedVendor">
          Nilai PO (DPP): <b>{{ fmt(selectedVendor.po_dpp) }}</b> &middot; Barang diterima: <b>{{ fmt(selectedVendor.received_dpp) }}</b> &middot; Sudah difakturkan: <b>{{ fmt(selectedVendor.invoiced_dpp) }}</b>
          <span class="text-danger" v-if="selectedVendor.currency != 'IDR'"> &middot; PO dalam {{ selectedVendor.currency }}, isi faktur dalam IDR</span>
        </p>

        <div class="row mt-2">
          <div class="col-md-3"><label class="form-control-label">No. Invoice Vendor <span style="color: red;">*</span></label><input type="text" class="form-control" v-model="form.invoice_no"></div>
          <div class="col-md-3"><label class="form-control-label">Tgl Invoice <span style="color: red;">*</span></label><input type="date" class="form-control" v-model="form.invoice_date"></div>
          <div class="col-md-3"><label class="form-control-label">Jatuh Tempo</label><input type="date" class="form-control" v-model="form.due_date"></div>
          <div class="col-md-3"><label class="form-control-label">DPP (IDR) <span style="color: red;">*</span></label><input type="number" step="0.01" min="0" class="form-control" v-model="form.dpp"></div>
        </div>
        <div class="row mt-2">
          <div class="col-md-2"><label class="form-control-label">PPN (%)</label><input type="number" step="0.01" min="0" class="form-control" v-model="form.ppn_rate"></div>
          <div class="col-md-4"><label class="form-control-label">No. Faktur Pajak <span v-if="Number(form.ppn_rate) > 0" style="color: red;">*</span></label><input type="text" class="form-control" placeholder="17 digit" v-model="form.faktur_pajak_no" :disabled="Number(form.ppn_rate) == 0"></div>
          <div class="col-md-3"><label class="form-control-label">Tgl Faktur Pajak <span v-if="Number(form.ppn_rate) > 0" style="color: red;">*</span></label><input type="date" class="form-control" v-model="form.faktur_pajak_date" :disabled="Number(form.ppn_rate) == 0"></div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6">
            <label class="form-control-label">Objek PPh (jasa / sewa)</label>
            <select class="form-select" v-model="form.pph_object_id">
              <option :value="null">Tidak ada PPh dipotong</option>
              <option v-for="(p, i) in pphObjects" :key="'p'+i" :value="p.id">{{ p.name }} ({{ Number(p.rate) }}%)</option>
            </select>
          </div>
          <div class="col-md-3" v-if="form.pph_object_id">
            <label class="form-control-label">Dasar PPh (kosong = DPP)</label>
            <input type="number" step="0.01" min="0" class="form-control" v-model="form.pph_base">
          </div>
          <div class="col-md-3"><label class="form-control-label">Catatan</label><input type="text" class="form-control" v-model="form.note"></div>
        </div>

        <!-- pratinjau perhitungan (perhitungan final tetap di server) -->
        <table class="table table-sm text-sm mt-3 mb-0" style="max-width: 520px;">
          <tbody>
            <tr><td>DPP</td><td class="text-end">{{ fmt(preview.dpp) }}</td></tr>
            <tr><td>PPN {{ Number(form.ppn_rate) }}%</td><td class="text-end">{{ fmt(preview.ppn) }}</td></tr>
            <tr><td class="font-weight-bold">Total Tagihan</td><td class="text-end font-weight-bold">{{ fmt(preview.dpp + preview.ppn) }}</td></tr>
            <tr v-if="preview.pphRate > 0">
              <td>PPh {{ preview.pphType }} {{ preview.pphRate }}% <span class="text-danger text-xs" v-if="preview.doubled">(2x, vendor tanpa NPWP)</span></td>
              <td class="text-end">({{ fmt(preview.pph) }})</td>
            </tr>
            <tr><td class="font-weight-bolder">Dibayar ke Vendor</td><td class="text-end font-weight-bolder">{{ fmt(preview.dpp + preview.ppn - preview.pph) }}</td></tr>
          </tbody>
        </table>
      </div>
      <div class="row float-right mt-3">
        <div class="col-12 text-end">
          <argon-button variant="gradient" color="secondary" size="sm" style="margin-right: 10px;" @click="formShow = false">Close</argon-button>
          <argon-button variant="gradient" color="info" size="sm" style="margin-right: 10px;" @click="save(false)" :disabled="onLoading">Simpan Draft</argon-button>
          <argon-button variant="gradient" color="success" size="sm" @click="save(true)" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i></span>
            <span v-else>Simpan & Posting</span>
          </argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccSupplierInvoice",
  components: {
    ArgonButton,
    VueFinalModal,
    BasePagination,
  },
  data() {
    return {
      moment: moment,
      pagination: { page_count: '', page: 1 },
      table: { data: [] },
      pphObjects: [],
      ppnRate: 11,
      search: { search: '', status: '', period: '' },
      formShow: false,
      form: {},
      vendors: [],
      onLoading: false,
    };
  },
  computed: {
    selectedVendor() {
      return this.vendors.find(v => v.vendor_code == this.form.vendor_code) || null;
    },
    preview() {
      let dpp  = Number(this.form.dpp || 0);
      let ppn  = Math.round(dpp * Number(this.form.ppn_rate || 0)) / 100;
      let obj  = this.pphObjects.find(p => p.id == this.form.pph_object_id);
      let rate = obj ? Number(obj.rate) : 0;
      let doubled = !!(obj && obj.pph_type == '23' && this.selectedVendor && !this.selectedVendor.has_npwp);
      if (doubled) rate = rate * 2;
      let base = (this.form.pph_base !== '' && this.form.pph_base !== null && this.form.pph_base !== undefined) ? Number(this.form.pph_base) : dpp;
      return { dpp: dpp, ppn: ppn, pph: Math.round(base * rate) / 100, pphRate: rate, pphType: obj ? obj.pph_type : '', doubled: doubled };
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    get() {
      let context = this;
      Api(context, accounting.supplierInvoices({ search: context.search.search, status: context.search.status, period: context.search.period, page: context.pagination.page })).onSuccess(function(response) {
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page;
          context.pphObjects            = response.data.data.pphObjects;
          context.ppnRate               = response.data.data.ppnRate;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    openForm(row) {
      this.vendors = [];
      this.form = row ? Object.assign({}, row, { pph_base: Number(row.pph_base) > 0 && Number(row.pph_base) != Number(row.dpp) ? row.pph_base : '' }) : {
        id: null, po_no: '', vendor_code: '', invoice_no: '', invoice_date: moment().format('YYYY-MM-DD'), due_date: '',
        faktur_pajak_no: '', faktur_pajak_date: moment().format('YYYY-MM-DD'), dpp: '', ppn_rate: this.ppnRate, pph_object_id: null, pph_base: '', note: '',
      };
      this.formShow = true;
      if (row) {
        this.loadSuggest(true);
      }
    },
    loadSuggest(keepValues) {
      let context = this;
      if (!context.form.po_no) {
        return alert('Isi No. PO dulu');
      }
      Api(context, accounting.suggestInvoice({ po_no: context.form.po_no })).onSuccess(function(response) {
          context.vendors = response.data.data.vendors;
          if (keepValues !== true) {
            context.form.vendor_code = context.vendors.length ? context.vendors[0].vendor_code : '';
            context.applySuggest();
          }
      }).onError(function(error) {
          context.vendors = [];
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'PO tidak ditemukan', 'error')
      })
      .call()
    },
    applySuggest() {
      let v = this.selectedVendor;
      if (!v || this.form.id) {
        return;
      }
      this.form.dpp           = v.suggest_dpp > 0 ? v.suggest_dpp : '';
      this.form.pph_object_id = v.suggest_pph_object_id;
      this.form.due_date      = v.next_due || '';
    },
    save(postNow) {
      let context = this;
      if (!context.form.po_no || !context.form.vendor_code || !context.form.invoice_no || !context.form.invoice_date || !(Number(context.form.dpp) > 0)) {
        return alert('PO, Vendor, No. Invoice, Tgl Invoice, dan DPP wajib diisi');
      }
      if (postNow && !confirm('Posting faktur? Setelah diposting, faktur masuk ke hutang, laporan pajak, dan jurnal.')) {
        return;
      }
      context.onLoading = true;
      let params = Object.assign({}, context.form, { post_now: postNow });
      Api(context, accounting.saveSupplierInvoice(params)).onSuccess(function() {
          context.formShow = false;
          context.notify(postNow ? 'Faktur Disimpan & Diposting' : 'Draft Faktur Disimpan', 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Faktur Gagal Disimpan', 'error')
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call();
    },
    action(type, row) {
      let label = { post: 'Posting', unpost: 'Batalkan posting', delete: 'Hapus' }[type];
      if (!confirm(label+' faktur '+row.invoice_no+'?')) {
        return;
      }
      let context = this;
      let service = { post: accounting.postSupplierInvoice, unpost: accounting.unpostSupplierInvoice, delete: accounting.deleteSupplierInvoice }[type];
      Api(context, service(row.id)).onSuccess(function() {
          context.notify(label+' berhasil', 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : label+' gagal', 'error')
      })
      .call();
    },
    changePage(page) {
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 4000 });
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 900px;
  max-height: 92vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
</style>
